var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 0C4.755 0 0 4.755 0 10.6C0 16.445 4.755 21.2 10.6 21.2C16.445 21.2 21.2 16.445 21.2 10.6C21.2 4.755 16.445 0 10.6 0ZM10.6 20C5.417 20 1.2 15.783 1.2 10.6C1.2 5.417 5.417 1.2 10.6 1.2C15.783 1.2 20 5.417 20 10.6C20 15.783 15.783 20 10.6 20ZM13.853 8.196L11.448 10.6L13.853 13.004C14.087 13.237 14.087 13.617 13.853 13.852C13.736 13.969 13.582 14.028 13.429 14.028C13.276 14.028 13.122 13.969 13.005 13.852L10.6 11.448L8.196 13.852C8.079 13.969 7.925 14.028 7.772 14.028C7.618 14.028 7.465 13.969 7.348 13.852C7.114 13.618 7.114 13.238 7.348 13.004L9.752 10.6L7.347 8.196C7.113 7.963 7.113 7.583 7.347 7.348C7.581 7.113 7.961 7.114 8.196 7.348L10.6 9.752L13.004 7.348C13.239 7.114 13.619 7.115 13.853 7.348C14.087 7.582 14.087 7.962 13.853 8.196Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ab29894f588d71f62862cc1f9021d0bf.svg";
export { ForwardRef as ReactComponent };